<template>
	<div class='container'>
		<div class='content'>
			<h2 class="title-centered"></h2>
			<p class="subtitle-centered">
				<b>{{ $t(`label.${info.subTitle}`) }}</b>
			</p>
			<p class="subtitle-centered">
				<a class="subtitle-centered no-link" href="mailto:escuelanamsan@gmail.com"><b>{{ $t(`label.${info.email}`) }}</b></a>
			</p>
		</div>
	</div>
</template>

<script>
export default {
  name: "ImageText",

  props: ["info"]
};
</script>

<style>

.container {
  background-image: url("../../assets/images/nam-san-home.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
  width: 101%;
  padding-bottom: 45%;
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 30px;
  right: 30px;
  font-size: 100%;
  color: #fff;
  text-shadow: 0 0 8px #000;
}

.title-centered h2 {
  margin: 0 0 16px;
}

.subtitle-centered {
  margin: 0 0 16px;
}

.subtitle-centered:last-of-type {
  margin-bottom: 0;
}

a.no-link {
  text-decoration: inherit;
  color: inherit;
}

@media (max-width: 833px) {
  .container {
    padding-bottom: 0;
  }
  .content {
    position: relative;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 80px 80px 140px;
  }
}

@media (max-width:400px) {
	.content {
    position: relative;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 80px 15px 70px;
  }
}
</style>
